import { useDisplayToken } from '@/domain/hooks/useDisplayToken'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Info } from '@/ui/molecules/info/Info'
import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'
interface TokenBalanceProps {
  token: Token
  balance: NormalizedUnitNumber
  isCombinedBalance?: boolean
  title?: string
  small?: boolean
}

export function TokenBalance({
  token,
  balance,
  isCombinedBalance,
  title = 'Balance',
  small = false,
}: TokenBalanceProps) {
  const displayToken = useDisplayToken(token)
  return (
    <div
      className={cn('my-4 flex flex-col gap-1', {
        'my-0 md:my-0': small,
      })}
    >
      <p className="text-muted-foreground text-xs">{title}: </p>

      <div className="flex items-center">
        <TokenIcon
          token={displayToken}
          className={cn('mr-2 h-6 w-6', {
            'h-5 w-5': small,
          })}
        />
        <p
          className={cn('flex items-center gap-2 font-semibold text-base md:text-xl', {
            'font-normal md:text-base': small,
          })}
          data-testid={testIds.marketDetails.walletPanel.balance}
        >
          {token.format(balance, { style: 'auto' })} {displayToken.symbol}
          {isCombinedBalance && <Info size={16}>WHYPE and HYPE balances are combined.</Info>}
        </p>
      </div>
    </div>
  )
}
